import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: null
};
const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserData: (state, { payload }) => {
            state.user = payload;
        },
    },
});

export const { setUserData } =
    userSlice.actions;

export default userSlice.reducer;
